var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBeigeBoatHat = function SvgBeigeBoatHat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 43,
    viewBox: "0 0 65 43",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3282 28.4139L0 20.0964L21.9491 19.4033L17.3282 28.4139Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3282 28.4139L0 20.0964L21.9491 19.4033L17.3282 28.4139Z",
    fill: "url(#boat_hat_paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6741 28.183L42.2808 19.1723L64.6919 18.2481L49.6741 28.183Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6741 28.183L42.2808 19.1723L64.6919 18.2481L49.6741 28.183Z",
    fill: "url(#boat_hat_paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3146 35.9476L32.4042 0.596558L52.4382 29.209L36.2655 38.3108L32.3146 35.9476Z",
    fill: "url(#boat_hat_paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4163 0.288269L9.08734 27.3785L32.4163 35.3515V0.288269Z",
    fill: "url(#boat_hat_paint3_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1151 0.513088L8.78619 27.6033L32.1151 35.5763V0.513088Z",
    fill: "url(#boat_hat_paint4_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62973 39.1995L0.308044 20.4658L30.571 24.8002L65 18.6175L58.1494 37.4911L31.7913 42.8603L7.62973 39.1995Z",
    fill: "url(#boat_hat_paint5_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32169 38.8912L0 20.1575L30.263 24.4918L64.692 18.3092L57.8413 37.1828L31.4833 42.552L7.32169 38.8912Z",
    fill: "url(#boat_hat_paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint0_linear",
    x1: 2.37805,
    y1: 16.1515,
    x2: 21.0061,
    y2: 28.2399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEDE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4F4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint1_linear",
    x1: 61.0366,
    y1: 16.5478,
    x2: 45.3811,
    y2: 32.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEDE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4F4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint2_linear",
    x1: 44.1175,
    y1: -7.5686,
    x2: 38.2955,
    y2: 69.5014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFF6EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint3_linear",
    x1: 27.4932,
    y1: -9.87732,
    x2: 27.9553,
    y2: 64.1313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEDE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557327,
    stopColor: "#5B4F4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint4_linear",
    x1: 41.814,
    y1: 6.83747,
    x2: 20.6098,
    y2: 58.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#FFF6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint5_linear",
    x1: 32.6531,
    y1: 4.3543,
    x2: 32.5,
    y2: 65.2978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4F4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint6_linear",
    x1: -39.6612,
    y1: 27.9357,
    x2: 91.5673,
    y2: 27.7816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6EE"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBeigeBoatHat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/beige_boat_hat.b53aaed9.svg";
export { ForwardRef as ReactComponent };